/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
 export default {

  sysManagement: { SC:"系统管理", TC: "系統管理", EN: "System" }
  ,update: { SC:"修改", TC: "修改", EN: "Edit" }
  ,delete: { SC:"删除", TC: "刪除", EN: "Delete" }
  ,audit: { SC:"日志", TC: "日誌", EN: "Log" }
  ,selectiveData: { SC:"请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." }
  ,deleteData: { SC:"数据删除中...", TC: "數據删除中...", EN: "Data is processing..." }
  ,deleteSuccess: { SC:"删除成功", TC: "刪除成功", EN: "Deleted successfully." }
  ,beQuerying: { SC:"查询中...", TC: "査詢中...", EN: "Searching..." }
  ,noneDate: { SC:"找不到符合条件记录.", TC: "找不到符合條件記錄.", EN: "No record is founed." }
  ,saveSuccess: { SC:"保存成功", TC: "保存成功", EN: "Saved successfully." }
  ,controls: { SC:"操作", TC: "操作", EN: "Operation" }
  ,list: { SC:"列表", TC: "列表", EN: "List" }
  ,search: { SC:"查询", TC: "査詢", EN: "Search" }
  ,reset: { SC:"重置", TC: "重置", EN: "Reset" }
  ,add: { SC:"新增", TC: "新增", EN: "Add" }
  ,save: { SC:"保存", TC: "保存", EN: "Save" }
  ,cancel: { SC:"取消", TC: "取消", EN: "Cancel" }
  ,dataBeSaving: { SC:"数据保存中...", TC: "數據保存中...", EN: "Data is processing..." }
   ,add2: { SC:"添加", TC: "添加", EN: "Add" }
   ,audit2: { SC:"审核", TC: "審核", EN: "Approve" }
   ,view: { SC:"查看", TC: "查看", EN: "View" }
   ,upload: { SC:"上传", TC: "上傳", EN: "Upload" }
   ,download: { SC:"下载", TC: "下載", EN: "Download" }
   ,Loading: { SC:"加载中...", TC: "加載中…", EN: "Loading..." }
   
   ,roleName: { SC:"角色名称", TC: "角色名稱", EN: "Role Name" }
   ,roleNameIsNoNull: { SC:"角色名称不能为空", TC: "角色名稱不能為空", EN: "Role Name is required." }
   ,roleCode: { SC:"角色编码", TC: "角色編碼", EN: "Role Code" }
   ,jHActiveInd: { SC:"激活状态", TC: "激活狀態", EN: "Active" }
   ,jHActiveIndIsNoNull: { SC:"激活状态不能为空", TC: "激活狀態不能為空", EN: "Active is required." }
   ,user: { SC:"用户", TC: "用戶", EN: "User" }
   ,password: { SC:"密码", TC: "密碼", EN: "Password" }
   ,role: { SC:"角色", TC: "角色", EN: "Role" }
   ,roleCode2: { SC:"角色编号", TC: "角色編號", EN: "Role Code" }
   ,roleCode2IsNoNull: { SC:"角色编号不能为空", TC: "角色編號不能為空", EN: "Role Code is required." }
   ,remark: { SC:"备注", TC: "備註", EN: "Remark" }
   ,dispSeq: { SC:"序号", TC: "序號", EN: "Seq" }
   ,funcName: { SC:"模块名称", TC: "模塊名稱", EN: "Function Name" }
   ,type: { SC:"模块类型", TC: "模塊類型", EN: "Function Type" }
   ,activeInd: { SC:"激活", TC: "激活", EN: "Active" }
   ,operation: { SC:"操作类型", TC: "操作類型", EN: "Operation" }
   
   ,sysManage: { SC:"系统管理", TC: "系統管理" , EN: "System" }
}